<template>
  <v-simple-table>
      <thead>
        <tr>
          <th>
            ID
          </th>
          <th>
            Reactants
          </th>
          <th>
            Products
          </th>
          <th>
            Download PDF
          </th>
          <th>
            Last evaluated in preferred values
          </th>
          <th>
            Last change in preferred values
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="text-left"
          v-for="datasheet in datasheets"
          :key="datasheet.pk.codeCategory+datasheet.pk.datasheetNumber"
        >
          <td>{{ datasheet.pk.codeCategory + datasheet.pk.datasheetNumber }}</td>
          <td v-html="datasheet.reactants"></td>
          <td v-html="datasheet.products"></td>
          <td><a target="_blank" :href="$prodPrefix+'datasheets/pdf/'+datasheet.pk.codeCategory+datasheet.pk.datasheetNumber+'.pdf'" download>download</a></td>
          <td>{{ datasheet.lastEvaluated }}</td>
          <td>{{ datasheet.lastAltered }}</td>
        </tr>
      </tbody>
  </v-simple-table>
</template>

<script>

export default {
  name: 'DatasheetsTable',

  props: ['datasheets'],
};
</script>